/**
 * Normalize a YouTube URL (any of: watch, youtu.be, embed, shorts) to an
 * embed URL. Returns null if the input can't be parsed.
 * Shared by the catalog detail page and any future preview.
 */
export function toYouTubeEmbed(url) {
  if (!url || typeof url !== "string") return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  try {
    const u = new URL(trimmed);
    let id = null;
    if (u.hostname.includes("youtu.be")) {
      id = u.pathname.split("/").filter(Boolean)[0] || null;
    } else if (u.hostname.includes("youtube.com")) {
      if (u.pathname === "/watch") id = u.searchParams.get("v");
      else if (u.pathname.startsWith("/embed/")) id = u.pathname.split("/")[2] || null;
      else if (u.pathname.startsWith("/shorts/")) id = u.pathname.split("/")[2] || null;
    }
    if (!id) return null;
    return `https://www.youtube.com/embed/${id}`;
  } catch {
    return null;
  }
}

export const CATEGORY_LABELS = {
  nuevo: "Nuevos",
  seminuevo: "Seminuevos",
  promocion: "Promociones",
};

export const CATEGORY_SLUGS_TO_KEY = {
  nuevos: "nuevo",
  seminuevos: "seminuevo",
  promociones: "promocion",
};

export const CATEGORY_KEY_TO_SLUG = {
  nuevo: "nuevos",
  seminuevo: "seminuevos",
  promocion: "promociones",
};

export function formatMXN(n) {
  const v = Number(n || 0);
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    maximumFractionDigits: 0,
  }).format(v);
}

// Central La Dupla Automotriz WhatsApp number (same as public footer)
export const LADUPLA_WHATSAPP = "529999980648";

export function whatsappLinkForUnit(titulo) {
  const text = encodeURIComponent(`Hola, me interesa la unidad ${titulo || ""}`.trim());
  return `https://wa.me/${LADUPLA_WHATSAPP}?text=${text}`;
}
